import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error('Missing Supabase environment variables:', {
    url: !!supabaseUrl,
    key: !!supabaseKey,
  });
}

// Module-top SSR guard: `localStorage` doesn't exist during static-site
// generation in Node. When the routes config is prerendered, this module is
// imported transitively (via AuthProvider). Without this guard the build crashes.
const isBrowser = typeof window !== "undefined";

export const supabase = createClient<Database>(supabaseUrl, supabaseKey, {
  auth: {
    storage: isBrowser ? window.localStorage : undefined,
    autoRefreshToken: isBrowser,
    persistSession: isBrowser,
    detectSessionInUrl: isBrowser,
    storageKey: 'dyna-auth',
  },
  global: {
    headers: {
      apikey: supabaseKey,
    },
  },
});